export default __webpack_public_path__ + "static/media/headShot.ed9e3f33.JPG";